import request from 'tools/request'
import {
  ClipoFactorWhiteLabelResponse,
  FactorSettingsResponse,
  FactorTimezoneResponse,
  FeatureFlagsResponse,
} from 'types/factor'

export const getWhiteLabel = async (clientPortalDomainUrl: string) => {
  const data = await request
    .get<ClipoFactorWhiteLabelResponse>('clientportal/factor/whitelabel', {
      params: {
        clientPortalDomainUrl: clientPortalDomainUrl,
      },
    })
    .then((res) => {
      return res.data.whiteLabelInfo
    })
  return data
}

export const getMeFactorSettings = async () => {
  const data = await request.get<FactorSettingsResponse>(`/factors/me/settings`).then((res) => res.data)
  return data
}

export const getFeatureFlags = async () => {
  const data = await request.get<FeatureFlagsResponse>(`/feature/feature-flags`).then((res) => res.data)
  return data
}

export const getMeFactorTimezone = async () => {
  const data = await request.get<FactorTimezoneResponse>(`/factors/me/timezone`).then((res) => res.data)
  return data
}
